<template>
    <div v-if="isClient" class="fixed inset-0 -z-10 pointer-events-none">
        <TresCanvas shadows alpha>
            <template #default>
                <TresPerspectiveCamera :position="[0, 10, 0]" :look-at="[-10, -10, -10]" />
                <TresAmbientLight :intensity="0.5" color="#ffffff" />
                <TresDirectionalLight :position="[0, 30, 20]" :intensity="2.5" color="#ff0000" cast-shadow />
                <TresPointLight :position="[-15, 1, -15]" :intensity="200" color="#ffffff" :distance="50"
                    :decay="2" />
                <TresPointLight :position="[15, 2, -10]" :intensity="250" color="#ffffff" :distance="50"
                    :decay="2" />
                <TresPointLight :position="[0, -1, 10]" :intensity="200" color="#ffffff" :distance="50"
                    :decay="2" />
                <Suspense>
                    <WaveGrid />
                    <template #fallback>
                        <div class="text-white">Carregando...</div>
                    </template>
                </Suspense>
            </template>
        </TresCanvas>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { TresCanvas } from '@tresjs/core';
import WaveGrid from '@/components/scenes/WaveGrid.vue';

const isClient = ref(false);

onMounted(() => {
    isClient.value = true;
});
</script> 